<script setup lang="ts">
import { mdiCheckBold } from '@mdi/js'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  disabled?: boolean
}

defineProps<Props>()

const model = defineModel<boolean>({ required: true })
</script>

<template>
  <div
    class="flex items-center justify-center w-5 h-5 border border-gray-300 dark:border-gray-800"
    :class="[model ? 'bg-brand' : 'dark:bg-black', disabled && 'bg-gray-100 dark:bg-gray-800']"
  >
    <SvgIcon
      v-if="model"
      :path="mdiCheckBold"
      class="w-5 h-5"
      :class="disabled ? 'fill-gray-300' : 'fill-white dark:fill-black'"
    />
  </div>
</template>
